import {EMAIL_CHANNEL_UID, SMS_CHANNEL_UID} from "@/modules/account/constants/channels";
import channelsService from "@/modules/channels/services/channelsService";
import Vue from "vue";

const helpers = {
  smsChannelBuilder: (smsParams = {}) => {
    const {channel = {}, multiMatterMode = false, isSmsEnabled= false, isSmsAvailable= false, isStar= false, hideSmsChannelFF = false} = smsParams;
    if(isStar){
      if(isSmsEnabled || !hideSmsChannelFF){
        let status = isSmsEnabled && (multiMatterMode || isSmsAvailable) ? 'active' : 'none'
        return helpers.channelObjectBuilder(channel, 1, status)
      }
    } else {
      if(isSmsEnabled && (multiMatterMode || isSmsAvailable)){
        return helpers.channelObjectBuilder(channel, 1)
      }
    }
  },
  emailChannelBuilder: (emailParams = {}) => {
    const {channel = {}, multiMatterMode= false, isStar= false, hideEmailChannelFF= false, currContact = {}} = emailParams;
    if(isStar && hideEmailChannelFF) return;
    if(multiMatterMode || currContact.email){
      return helpers.channelObjectBuilder(channel, 1,  'active')
    }
  },
  otherChannelBuilder: (params) => {
    const {channel = {}, multiMatterMode = false} = params;
    if(channel.open_channel){
      return helpers.channelObjectBuilder(channel, 1, 'active')
    }
    else{
      return helpers.sessionBasedChannelBuilder(params)
    }
  },
  sessionBasedChannelBuilder: (params) =>{
    const {channel = {}, multiMatterMode = false} = params;
    if(channel.status === 'active'){
      return helpers.channelObjectBuilder(channel, 1)
    }
    else if(!multiMatterMode){
      return helpers.channelObjectBuilder(channel, 2)
    }
  },
  channelObjectBuilder: (currentChannel, level, status) => {
    return {
      ...currentChannel,
      text: currentChannel.app_name,
      level: level,
      active: status ? status : currentChannel.status
    }
  },
};

const state = {
  channels:[],
  filteredChannels:[]
}

const getters = {
  channels: state => state.channels,
  filteredChannels: state => state.filteredChannels,
}

const mutations = {
  setChannels(state, channels) {
    state.channels = channels
  },
  setFilteredChannels(state, filteredChannels) {
    state.filteredChannels = filteredChannels
  },
}

const actions = {
  setDefaultChannels({commit}) {
    commit('setChannels', [
      {
        app_code_name: 'email',
        app_name: 'Email',
        channel: 'email',
        value: EMAIL_CHANNEL_UID,
        channel_uid: EMAIL_CHANNEL_UID,
        order: 1,
        status: 'active',
        type: 'core',
      },{
        app_code_name: 'sms',
        app_name: 'SMS',
        channel: 'sms',
        value: SMS_CHANNEL_UID,
        channel_uid: SMS_CHANNEL_UID,
        order: 1,
        status: 'active',
        type: 'core',
      },
    ])
  },
  async loadChannels({commit, state, dispatch, rootGetters}, {clientUid, multiMatterMode}) {
    const openChannelSelectorFF = rootGetters.hasFeature('open_channel_selector');
    const isBusinessChannelsSource = openChannelSelectorFF && multiMatterMode;
    const res = isBusinessChannelsSource ? await channelsService.getBusinessChannels() : await channelsService.getChannels(clientUid)

    if (res.success) {
      const channels = isBusinessChannelsSource ? res.data.channels : res.data.contact;
      channels.forEach(channel => {
        channel.value = channel.channel_uid;
        if (openChannelSelectorFF) {
          switch (channel.app_code_name) {
            case 'sms':
              channel.icon = 'icon-Apple_Business_Chat';
              break;
            case 'email':
              channel.icon = 'icon-Mail';
              break;
            default:
              channel.icon = 'icon-placeholder';
              const logo = channel.description?.logo;
              if (logo && logo.toLowerCase().endsWith('.svg')) {
                channel.logo = logo;
              }
          }
        } else {
          switch (channel.app_code_name) {
            case 'sms':
              channel.icon = 'icon-Apple_Business_Chat';
              break;
            case 'email':
              channel.icon = 'icon-Mail';
              break;
            case 'centralized_inbox':
            case 'webchat':
            case 'webchat_448':
              channel.logo = 'web-chat'
              channel.icon = 'icon-web-chat';
              break;
            case 'instagram':
            case 'instagram_463':
              channel.logo = 'instagram'
              channel.icon = 'icon-Apple_Business_Chat';
              break;
            case 'google':
              channel.logo = 'google'
              channel.icon = 'icon-Google-My-Business-Chat';
              break;
            case 'gbmprod':
            case 'gbm':
              channel.logo = 'google';
              channel.icon = 'icon-Google';
              break;
            case 'messenger':
            case 'facebookmessenger':
            case 'facebookmessenger_447':
              channel.logo = 'messager'
              channel.icon = 'icon-FB-messager';
              break;
            default:
              channel.logo = 'apple';
              channel.icon = 'icon-Marketing';
          }
        }
      })
      commit('setChannels', channels)
    } else {
      dispatch('setDefaultChannels')
    }
  },
  filterChannelsWithOpenChannels: ({state, dispatch, rootState, rootGetters}, multiMatterMode = false) => {
    const isStar = rootGetters['accountModule/isStar'];
    const integrationsSettings = rootGetters['accountModule/integrationsSettings'];
    const isSmsEnabled = rootGetters['accountModule/isSmsEnabled'];
    const isSmsAvailable = rootGetters['mattersModule/isSmsAvailable'];
    const communicationChannelUiFF = rootGetters.hasFeature('communication_channel_ui');

    const filteredChannels = state.channels.map(channel => {
      switch (channel.app_code_name) {
        case 'sms':
          const hideSmsChannelFF = rootGetters.hasFeature('hide_sms_channel')
          const smsParams = { channel, multiMatterMode, isSmsEnabled, isSmsAvailable, isStar, hideSmsChannelFF }
          return helpers.smsChannelBuilder(smsParams)
        case 'email':
          const hideEmailChannelFF = rootGetters.hasFeature('hide_email_channel')
          const currContact = rootState.mattersModule.currContact
          const emailParams = { channel, multiMatterMode, isStar, hideEmailChannelFF, currContact }
          return helpers.emailChannelBuilder(emailParams)
        default:
          const params = { channel, multiMatterMode }
          return helpers.otherChannelBuilder(params)
      }
    }).filter(onlyAvailableChannels => onlyAvailableChannels);

    if(communicationChannelUiFF && isStar && integrationsSettings.app_market_url) {
      const exploreChannelsItem = {
        channel:'explore-channels',
        text: Vue.prototype.$t('client.matters.conversation.channels.app_store'),
        level: 3,
        icon: 'icon-Channel',
        link: 'https://command.thryv.com/inbox/add-channels',
        linkTarget: '_blank'
      }
      filteredChannels.push(exploreChannelsItem)
    }
    //show channels with installed == true or installed is undefined
    dispatch('setFilteredChannels', filteredChannels.filter(channel => !(channel.installed === false)));
  },
  setFilteredChannels({commit, state, dispatch}, filteredChannels) {
    // ordering uninstall and install app a-z to each group inside level 2
    const sortByText = (a, b) => {
      if(a.text.toLowerCase() > b.text.toLowerCase()) {
        return 1
      } else if (a.text.toLowerCase() === b.text.toLowerCase()) {
        return 0
      }
      return -1
    }

    const activeChannels = filteredChannels.filter(channel => channel.level === 1)
    const inactiveChannels = filteredChannels.filter(channel => channel.level === 2)
    const otherChannels = filteredChannels.filter(channel => channel.level === 3)

    const activeChannelsSorted = activeChannels.sort(sortByText)
    const inactiveChannelsSorted = inactiveChannels.sort(sortByText)

    let lastKnownPosition = 0;
    inactiveChannelsSorted.forEach((channel, i) => channel.position = lastKnownPosition = i)
    activeChannelsSorted.forEach(channel => channel.position = ++lastKnownPosition)

    filteredChannels = [...activeChannelsSorted, ...inactiveChannelsSorted, ...otherChannels]

    commit('setFilteredChannels', filteredChannels);
    dispatch('systemUpdatedChannel');
  },

  userSelectedChannel({dispatch}, payload) {
    dispatch('mattersModule/setChannel', payload, {root:true})
  },

  systemUpdatedChannelForOpenChannels({dispatch, state, rootState}){
    let lastMassageOrigin = rootState.mattersModule.conversation.messages[0]?.channel_uid;
    const lastChannelAvailable = state.filteredChannels.find(channel => channel.channel_uid === lastMassageOrigin && channel.status === 'active');
    const nextActiveChannel = state.filteredChannels.find(channel => channel.status === 'active' || channel.open_channel)
    const defaultChannel = lastChannelAvailable ? lastChannelAvailable : nextActiveChannel
    if (defaultChannel)
      dispatch('mattersModule/setChannel', defaultChannel.channel_uid, {root:true});
  },
  systemUpdatedChannelWithoutOpenChannel({state, dispatch, rootState, rootGetters}){
    let lastMassageOrigin = rootState.mattersModule.conversation.messages[0]?.channel_uid || EMAIL_CHANNEL_UID;
    if (lastMassageOrigin === SMS_CHANNEL_UID) {
      if (!rootGetters['mattersModule/isSmsAvailable'] || !rootState.accountModule.isSmsEnabled) {
        lastMassageOrigin = EMAIL_CHANNEL_UID;
      }
    } else if (lastMassageOrigin !== EMAIL_CHANNEL_UID) {
      const lastChannel = state.channels.find(channel => channel.channel_uid === lastMassageOrigin)
      if(!lastChannel || lastChannel.disabled) {
        lastMassageOrigin = EMAIL_CHANNEL_UID;
      } else if (lastChannel.status === 'inactive') {
        const nextActiveChannel = state.channels.find(channel => channel.status === 'active')
        if(nextActiveChannel) {
          lastMassageOrigin = nextActiveChannel.channel_uid
        } else {
          lastMassageOrigin = EMAIL_CHANNEL_UID;
        }
      }
    }
    const channel = state.channels?.find(channel =>  channel.channel_uid === lastMassageOrigin);
    dispatch('mattersModule/setChannel', channel?.channel_uid || EMAIL_CHANNEL_UID, {root:true});
  },

  systemUpdatedChannel({rootGetters, dispatch}) {
    const openChannelSelectorFF = rootGetters.hasFeature('open_channel_selector');
    openChannelSelectorFF ? dispatch('systemUpdatedChannelForOpenChannels') : dispatch('systemUpdatedChannelWithoutOpenChannel');
  },
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  helpers
}
